module.exports = __webpack_public_path__ + "img/Opplysningstid_Klassisistisk-arkitektur-Jenisch-Haus.c1ef09e4.jpg";